import { path, assocPath, mergeLeft } from "ramda";
import { curryN } from "ramda";
export default curryN(3, (p, v, x) => assocPath(p, mergeLeft(path(p, x), v), x));
//# sourceMappingURL=mergeLeftPath.mjs.map